import { render, staticRenderFns } from "./informDetail.vue?vue&type=template&id=4ffc7211&scoped=true&"
import script from "./informDetail.vue?vue&type=script&lang=js&"
export * from "./informDetail.vue?vue&type=script&lang=js&"
import style0 from "./informDetail.vue?vue&type=style&index=0&id=4ffc7211&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffc7211",
  null
  
)

export default component.exports